import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import inputFormReducer from './inputFormSlice';
import searchParamsReducer from './searchParamsSlice';
import menuBarReducer from './menuSlice';
import promptOptimizerReducer from './promptOptimizerSlice';
import optionsReducer from './optionsSlice';
import questionAnswersReducer from './questionsSlice';
import tripadvisorReducer from './tripadvisorSlice';
import googlePlacesReducer from './googlePlacesSlice';

import backOfficeMenuBarReducer from '../backOffice/redux/menuSlice';


const store = configureStore({
  reducer: {
    auth: authReducer,
    inputForm: inputFormReducer,
    searchParams: searchParamsReducer,
    menuBar: menuBarReducer,
    promptOptimizer: promptOptimizerReducer,
    options: optionsReducer,
    questionAnswers: questionAnswersReducer,
    tripadvisor: tripadvisorReducer,
    googlePlaces: googlePlacesReducer,

    backOfficeMenuBar: backOfficeMenuBarReducer,
  },
});

export default store;
